import arrowImg from "../../../../../picture/PlayLanguage.png";
import { useEffect, useRef, useState } from "react";

const styles = {
  option: {
    wordBreak: "break-word",
    padding: "5px 10px",
    borderBottom: "1px solid black",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    fontSize: "16px",
    gap: "5px"
  }
};

// values are objects {id, name}[]
const CustomSelectMultipleTwoColumns = ({
  allValues,
  selectedValues,
  onSelectChange,
  label,
  displayNumber = false,
  style = {}
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);
  const optionsRef = useRef(null);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };
  const handleSelect = (value) => {
    if (onSelectChange) onSelectChange(value);
  };

  useEffect(() => {
    const rect = selectRef.current.getBoundingClientRect();
    optionsRef.current.style.width = rect.width + "px";

    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={selectRef} style={style}>
      <div
        style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "5px" }}
      >
        {label}
      </div>
      <div onClick={handleOpen} style={{ position: "relative" }}>
        <input
          type="text"
          value={displayNumber ? selectedValues.length || "" : ""}
          readOnly
          style={{
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "16px",
            height: "40px",
            padding: "10px"
          }}
        />
        <div
          style={{
            width: "30px",
            position: "absolute",
            right: "0px",
            top: "12px"
          }}
        >
          <img
            src={arrowImg}
            alt=""
            className="profile-select-item-img"
            style={{ transform: isOpen ? "rotate(-90deg)" : "rotate(90deg)" }}
          />
        </div>
      </div>
      <div
        ref={optionsRef}
        style={{
          position: "fixed",
          zIndex: "10",
          display: isOpen ? "flex" : "none",
          boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.15)",
          width: "100%",
          maxHeight: "200px",
          overflowY: "auto",
          ...style
        }}
      >
        <div style={{ width: "50%" }}>
          {allValues
            .filter((value, index) => index < allValues.length / 2)
            .map((value, index) => (
              <div
                key={value.id}
                onClick={() => handleSelect(value)}
                style={{
                  ...styles.option,
                  backgroundColor: selectedValues.find((v) => v.id === value.id)
                    ? "lightgrey"
                    : "white"
                }}
              >
                <input
                  type="checkbox"
                  checked={!!selectedValues.find((v) => v.id === value.id)}
                />
                <div>{value.name}</div>
              </div>
            ))}
        </div>

        <div style={{ width: "50%" }}>
          {allValues
            .filter((value, index) => index >= allValues.length / 2)
            .map((value, index) => (
              <div
                key={value.id}
                onClick={() => handleSelect(value)}
                style={{
                  ...styles.option,
                  backgroundColor: selectedValues.find((v) => v.id === value.id)
                    ? "lightgrey"
                    : "white"
                }}
              >
                <input
                  type="checkbox"
                  checked={!!selectedValues.find((v) => v.id === value.id)}
                />
                <div>{value.name}</div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default CustomSelectMultipleTwoColumns;
